import { Component } from '@angular/core';

@Component({
  templateUrl: 'repossessed.component.html'
})
export class RepossessedComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/repossessed.component.ts